module.exports = __webpack_public_path__ + "static/textoDerecha-d0b9eb309c6ec8062997ef12d017e7c5.png";